export enum NomePaginaEnum {
  ENTIDADE = 'entidade',
  VINCULO = 'vinculo',
  PESSOA = 'pessoa',
}
